import { Stack, Text } from "@chakra-ui/react";
import React from "react";
import { BsQuote } from "react-icons/bs";
import { useColorModeValue } from "../ui/color-mode";

const Testimonial = ({ review, name }) => {
  const bg = useColorModeValue("#f6f6ff", "#1a1625");
  const textColor = useColorModeValue("black", "gray.400");

  return (
    <>
      <Stack
        bg={bg}
        justifyContent="center"
        borderRadius="3xl"
        boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px;"
        width={{ base: "xs", md: "md", lg: "md" }}
        m="auto"
        gap="6"
        p={6}
        minH="300px"
        color={textColor}
      >
        <BsQuote color="#66b2b2" size="50" />
        <Text fontSize={{ base: "sm", md: "md" }}>{review}</Text>
        <Stack gap="0">
          <Text>--</Text>
          <Text fontWeight="500">{name}</Text>
        </Stack>
      </Stack>
    </>
  );
};

export default Testimonial;
